import GsapCarousel from '../library/GsapCarousel'
export default class Testimonials {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.slides = this.el.querySelectorAll('[data-testimonial]')
  }

  init() {
    if (this.slides.length > 1) {
      GsapCarousel.init({
        el: this.el,
        autoContainerHeight: true,
      })
    }
  }
}
